
import React, { useState, useEffect } from 'react';
import { api } from '../apiClient';

const AdminOrderManagement = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/orders');
      setOrders(response.data);
    } catch (err) {
      setError('Failed to fetch orders.');
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await api.put(`/admin/orders/${orderId}/status`, null, { params: { status: newStatus } });
      fetchOrders(); // Refresh the list of orders
    } catch (err) {
      setError('Failed to update order status.');
    }
  };

  if (loading) {
    return <p>Loading orders...</p>;
  }

  if (error) {
    return <p className="text-red-500">{error}</p>;
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Order Management</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white">
          <thead>
            <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
              <th className="py-3 px-6 text-left">Order ID</th>
              <th className="py-3 px-6 text-left">Customer</th>
              <th className="py-3 px-6 text-left">Total</th>
              <th className="py-3 px-6 text-left">Payment Status</th>
              <th className="py-3 px-6 text-left">Fulfillment Status</th>
              <th className="py-3 px-6 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="border-b border-gray-200 hover:bg-gray-100">
                <td className="py-3 px-6 text-left whitespace-nowrap">{order.id}</td>
                <td className="py-3 px-6 text-left">{order.shipping_address.first_name} {order.shipping_address.last_name}</td>
                <td className="py-3 px-6 text-left">${order.total_amount.toFixed(2)}</td>
                <td className="py-3 px-6 text-left">{order.payment_status}</td>
                <td className="py-3 px-6 text-left">{order.fulfillment_status}</td>
                <td className="py-3 px-6 text-center">
                  <select
                    value={order.fulfillment_status}
                    onChange={(e) => handleStatusChange(order.id, e.target.value)}
                    className="mt-1 block w-full p-3 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
                  >
                    <option value="draft">Draft</option>
                    <option value="pending_fulfillment">Pending Fulfillment</option>
                    <option value="in_production">In Production</option>
                    <option value="shipped">Shipped</option>
                    <option value="delivered">Delivered</option>
                    <option value="canceled">Canceled</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminOrderManagement;
